"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useConsent } from "@/context/ConsentContext";

export default function CookieConsentBanner() {
	const t = useTranslations("CookieBanner");
	const tFooter = useTranslations("Footer");
	const { consent, hasHydrated, setConsent } = useConsent();

	// Don't show banner until we've read consent from localStorage (avoids flash on refresh)
	if (!hasHydrated || consent !== null) return null;

	return (
		<div
			className="fixed bottom-0 left-0 right-0 z-[9999] bg-slate-800 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.15)]"
			role="dialog"
			aria-label="Cookie consent"
		>
			<div className="w-full section-padding py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
				<p className="text-[1.4rem] text-slate-200 leading-relaxed">
					{t("message")}{" "}
					<Link
						href="/cookie"
						className="text-bdt-gold hover:underline no-underline"
					>
						{tFooter("cookiePolicy")}
					</Link>
					.
				</p>
				<div className="flex flex-wrap gap-3 shrink-0">
					<button
						type="button"
						onClick={() => setConsent("essential")}
						className="px-4 py-2 text-[1.4rem] rounded-lg border border-slate-500 text-white hover:bg-slate-700 transition-colors"
					>
						{t("essentialOnly")}
					</button>
					<button
						type="button"
						onClick={() => setConsent("all")}
						className="px-4 py-2 text-[1.4rem] rounded-lg bg-bdt-gold text-slate-900 font-medium hover:opacity-90 transition-opacity"
					>
						{t("acceptAll")}
					</button>
				</div>
			</div>
		</div>
	);
}
